<script setup lang="ts">
import { computed } from 'vue'
import { usePwaStore } from '~~/stores/pwaStore'
import { usePwa } from '~/composables/usePwa'

// usePwaFeatureFlag jako auto-import — testy mockują je przez mockNuxtImport.
const pwaEnabled = usePwaFeatureFlag()
const store = usePwaStore()
const { canOfferInstall } = usePwa()

// Self-gating: przycisk pojawia się tylko gdy PWA włączona dla usera i instalacja
// jest w ogóle możliwa (Android beforeinstallprompt lub iOS Safari), a apka nie
// jest już zainstalowana. Dzięki temu można go wstawić w dowolnym miejscu UI.
const visible = computed(() => pwaEnabled.value && canOfferInstall())

function onClick() {
  store.openInstallModal('manual')
}
</script>

<template>
  <button
    v-if="visible"
    type="button"
    class="pwa-install-btn"
    @click="onClick"
  >
    <span class="pwa-install-btn__icon" aria-hidden="true">📲</span>
    <span>{{ $t('pwa.install.buttonLabel') }}</span>
  </button>
</template>

<style scoped>
.pwa-install-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: 1px solid var(--color-border, #ddd);
  border-radius: 8px;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

[data-brand="youlook"] .pwa-install-btn {
  border-radius: 0;
}

.pwa-install-btn:hover {
  border-color: var(--color-primary, #151515);
}

.pwa-install-btn__icon {
  font-size: 1.1rem;
  line-height: 1;
}
</style>
